import { useContext, useEffect, useState } from "react"
import API from "./API"
import { AdminQueryApprovers, AdminQueryCenter, AdminQueryCompany, AdminQueryOrder, AdminQueryPersonOrder, AdminQueryPersonReporting, AdminQueryPosition, AdminQueryProject } from "../../backend/src/api/dto"
import { Link, useNavigate, useParams } from "react-router"
import { Controller, useForm } from "react-hook-form"
import DatePicker from 'react-datepicker'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { adminLevels, personSorts, personStatuses, personTypes, yesNo } from "./constants"
import { lookupFromObjectsArray } from "./global"
import { ModalContext } from './ModalContext';
import AdminAddApproverToUser from "./Modal/AdminAddApproverToUser"
import { AdminAddApproverToUserFunction, AdminAddOrderToUserFunction } from "./interfaces"
import ModalConfirmation from "./Modal/Confirmation"
import AdminChangeUserPassword from "./Modal/AdminChangeUserPassword"
import AdminAddOrderToUser from "./Modal/AdminAddOrderToUser"
import ApiResult from "./ApiResult"
import DisplayTimeReportState from "./components/DisplayTimeReportState"
import { UserContext } from './UserContext';
import { ContextType } from './interfaces'
import AdminLevel from "./AdminLevel"


type FormValues = {
    nameId: string
    name: string
    surname: string
    sort: number,
    type: number
    centerId: number
    companyId: number
    status: number
    positionId: number
    startDate: string | null
    endDate: string | null
    email: string
    monthOvertimeHours: number
    nonWorkingDayEntries: number
    maxDayHours: number
    stdDayHours: number
    adminLevel: number
}


function Person() {

    const params = useParams();
    let navigate = useNavigate();

    const [data, setData] = useState<{
        centers: AdminQueryCenter[],
        companies: AdminQueryCompany[],
        positions: AdminQueryPosition[],
        projects: AdminQueryProject[],

        approvers: AdminQueryApprovers[],
        approverFor: AdminQueryApprovers[],
        orders: AdminQueryPersonOrder[],
        reportings: AdminQueryPersonReporting[]
    }>({

        centers: [],
        companies: [],
        positions: [],
        approvers: [],
        approverFor: [],
        orders: [],
        projects: [],
        reportings: []
    })

    const [showModal, closeModal] = useContext(ModalContext);
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const { currentUser, setCurrentUser } = useContext(UserContext) as ContextType;
    const [visibility, setVisibility] = useState(0);
    const [loading, setLoading] = useState(true)
    const [loading2, setLoading2] = useState(true)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {
            if (params.personId !== "0") {
                const person = await API.getPerson(params.personId ?? 0)
                setData(prevData => {
                    return {
                        ...prevData,
                        approvers: person.approvers,
                        approverFor: person.approverFor,
                        orders: person.orders,
                        reportings: person.reportings
                    }

                })
                setLoading(false)
                return person.person
            } else {
                setLoading(false)
                return {
                    nameId: '',
                    name: '',
                    surname: '',
                    sort: 0,
                    type: 0,
                    centerId: 0,
                    companyId: 0,
                    status: 1,
                    positionId: 0,
                    startDate: null,
                    endDate: null,
                    email: '',
                    monthOvertimeHours: 0,
                    nonWorkingDayEntries: 0,
                    maxDayHours: 16,
                    stdDayHours: 8,
                    adminLevel: 0,
                }
            }
        }
    })

    useEffect(() => {
        setLoading2(true)
        Promise.all([
            API.getCenters(),
            API.getCompanies(),
            API.getPositions(),
            API.getProjects({}),
        ]).then(res => {
            setData(prevData => {
                return {
                    ...prevData,
                    centers: res[0],
                    companies: res[1],
                    positions: res[2].positions,
                    projects: res[3]
                }

            })
            setLoading2(false)
        })
    }, [])


    const addUser = () => {
        API.addPerson(params.personId ?? 0, getValues()).then((res) => {
            setApiResult(null)
            navigate('/dashboard/person')
        }).catch((e) => {
            setApiResult(e)
        })
    }

    const saveUser = () => {

        API.savePerson(params.personId ?? 0, getValues()).then((res) => {
            setApiResult(null)
            navigate('/dashboard/person')
        }).catch((e) => {
            setApiResult(e)
        })
    }

    const reloadData = (): Promise<any> => {
        return API.getPerson(params.personId ?? 0).then(person => {
            setData(prevData => {
                return {
                    ...prevData,
                    approvers: person.approvers,
                    orders: person.orders
                }
            })
        })

    }


    const addApprover: AdminAddApproverToUserFunction = (approverId: number | string) => {
        return API.addApproverToUser(params.personId ?? 0, approverId)
    }

    const removeApprover = (approverId: number | string) => {
        return API.deleteApproverFromUser(params.personId ?? 0, approverId).then(() => {
            return reloadData()
        })
    }

    const changePassword = (password: string) => {
        return API.setPersonPassword(params.personId ?? 0, { password })
    }

    const addOrder: AdminAddOrderToUserFunction = (orderId: number | string, startDate: string, endDate: string) => {
        return API.addOrderToUser(params.personId ?? 0, orderId, startDate, endDate)
    }

    const removeOrder = (orderId: number | string) => {
        return API.deleteOrderFromUser(params.personId ?? 0, orderId).then(() => {
            return reloadData()
        })
    }

    const deletePerson = () => {
        return API.deletePerson(params.personId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/person')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const toggleCalendar = (mask: number) => {
        setVisibility(prevData => prevData ^= mask)
    }



    if (loading || loading2) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Osoba: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    if (!data.centers.filter(c => c.status).length || !data.companies.filter(c => c.status).length || !data.positions.filter(p => p.status).length || !data.projects.filter(p => p.status).length) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Osoba: ...</div>
                    </div>
                    <div className="card-body">
                        <div className="alert alert-warning" role="alert"><FontAwesomeIcon fixedWidth size="2x" icon={["fas", "exclamation-triangle"]} /> Nie sú k dispozícii všetky potrebné údaje. Skontrolujte či je pridané aspoň jedno aktívne stredisko ({data.centers.filter(c => c.status).length}), spoločnosť ({data.companies.filter(c => c.status).length}), pozícia ({data.positions.filter(p => p.status).length}) a projekt ({data.projects.filter(p => p.status).length}).</div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/person" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Osoba: <strong>{
                                params.personId === "0" ? '[ Vytvoriť novú ]' : <span>{getValues().name} {getValues().surname}</span>
                            }</strong></div>
                        </div>

                        <div className="col-5 text-end">
                            <AdminLevel level={9} match="greaterOrEqual">
                                {
                                    params.personId !== "0" ?
                                        <button className="btn btn-warning" onClick={
                                            () => showModal(
                                                <AdminChangeUserPassword
                                                    changeFunction={changePassword}
                                                />
                                            )
                                        }><FontAwesomeIcon fixedWidth icon={["fas", "key"]} /> Zmeniť heslo</button>
                                        : null
                                }
                                {
                                    params.personId === "0" ?
                                        <button className="btn btn-primary" onClick={addUser}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať osobu</button>
                                        :
                                        <>
                                            {
                                                !loading && !data.approvers.length && !data.orders.length && !data.reportings.length && !data.approverFor.length ?
                                                    <button className="btn btn-danger ms-3" onClick={() => showModal(
                                                        <ModalConfirmation
                                                            confirm={deletePerson}
                                                            title={"Naozaj zmazať osobu?"}
                                                            text="" />
                                                    )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Zmazať osobu</button>
                                                    : null
                                            }
                                            <button className="btn btn-primary ms-3" onClick={saveUser}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť osobu</button>
                                        </>
                                }
                            </AdminLevel>
                        </div>
                    </div>
                </div>
                <div className="card-body">

                    <ApiResult errorObject={apiResult} />

                    <div className="row">
                        <div className="col-3">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">ID osoby</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("nameId")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Meno</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Priezvisko</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("surname")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Druh</label>
                                </div>
                                <div className="col-8">
                                    <select {...register("sort")} className="form-select form-select-sm" >
                                        {
                                            personSorts.map(sort => {
                                                return (
                                                    <option value={sort.id}>{sort.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Typ</label>
                                </div>
                                <div className="col-8">
                                    <select {...register("type")} className="form-select form-select-sm" >
                                        {
                                            personTypes.map(type => {
                                                return (
                                                    <option value={type.id}>{type.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Stredisko</label>
                                </div>
                                <div className="col-8">
                                    <select {...register("centerId")} className="form-select form-select-sm" >
                                        {
                                            data.centers.filter(item => {
                                                return currentUser.settings.showInactive || (!currentUser.settings.showInactive && item.status)
                                            }).map(center => {
                                                return (
                                                    <option value={center.centerId}>{center.name} ({center.description})</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Firma</label>
                                </div>
                                <div className="col-8">
                                    <select {...register("companyId")} className="form-select form-select-sm" >
                                        {
                                            data.companies.filter(item => {
                                                return currentUser.settings.showInactive || (!currentUser.settings.showInactive && item.status)
                                            }).map(company => {
                                                return (
                                                    <option value={company.companyId}>{company.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Stav</label>
                                </div>
                                <div className="col-8">
                                    <select {...register("status")} className="form-select form-select-sm" >
                                        {
                                            personStatuses.map(status => {
                                                return (
                                                    <option value={status.id}>{status.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Pozícia</label>
                                </div>
                                <div className="col-8">
                                    <select {...register("positionId")} className="form-select form-select-sm" >
                                        <option value={0}>[ Vyberte ]</option>
                                        {
                                            data.positions.filter(item => {
                                                return currentUser.settings.showInactive || (!currentUser.settings.showInactive && item.status)
                                            }).map(position => {
                                                return (
                                                    <option value={position.positionId}>{position.name} ({position.description})</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Štart</label>
                                </div>
                                <div className="col-auto">
                                    <Controller
                                        control={control}
                                        name='startDate'
                                        render={({ field }) => (
                                            <>
                                                <div className="input-group">
                                                    <input type="text" className="form-control form-control-sm" value={field.value?.toString().split("T")[0]} onChange={(date) => field.onChange(date)} placeholder="RRRR-MM-DD" />
                                                    <span className="input-group-text" onClick={() => toggleCalendar(1)}><FontAwesomeIcon fixedWidth icon={["fas", "calendar-days"]} /></span>
                                                </div>
                                                <div style={{ position: 'relative' }}>
                                                    {
                                                        visibility & 1 ?
                                                            <div style={{ position: 'absolute', top: '10px', zIndex: 10 }}>
                                                                <DatePicker
                                                                    onChange={
                                                                        (date) => {
                                                                            const isoDateindex = date?.getFullYear() + '-' + ('0' + (date?.getMonth()! + 1)).slice(-2) + '-' + ('0' + date?.getDate()).slice(-2)
                                                                            field.onChange(isoDateindex)
                                                                            toggleCalendar(1)
                                                                        }
                                                                    }
                                                                    selected={field.value ? new Date(field.value) ?? null : null}
                                                                    dateFormat='YYYY-MM-dd'
                                                                    inline
                                                                />
                                                                <svg fill="currentColor" className="react-datepicker__triangle__arrow" aria-hidden="true" width="18" height="16" viewBox="0 0 16 16"><path clip-path="url(#«r4»)" fill="none" stroke-width="3" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><path stroke="currentColor" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><clipPath id="«r4»"><rect x="-1" y="1" width="18" height="16"></rect></clipPath></svg>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Koniec</label>
                                </div>
                                <div className="col-auto">
                                    <Controller
                                        control={control}
                                        name='endDate'
                                        render={({ field }) => (
                                            <>


                                                <div className="input-group">
                                                    <input type="text" className="form-control form-control-sm" value={field.value?.toString().split("T")[0]} onChange={(date) => field.onChange(date)} placeholder="RRRR-MM-DD" />
                                                    <span className="input-group-text" onClick={() => toggleCalendar(2)}><FontAwesomeIcon fixedWidth icon={["fas", "calendar-days"]} /></span>
                                                </div>
                                                <div style={{ position: 'relative' }}>
                                                    {
                                                        visibility & 2 ?
                                                            <div style={{ position: 'absolute', top: '10px', zIndex: 10 }}>
                                                                <DatePicker
                                                                    onChange={
                                                                        (date) => {
                                                                            const isoDateindex = date?.getFullYear() + '-' + ('0' + (date?.getMonth()! + 1)).slice(-2) + '-' + ('0' + date?.getDate()).slice(-2)
                                                                            field.onChange(isoDateindex)
                                                                            toggleCalendar(2)
                                                                        }
                                                                    }
                                                                    selected={field.value ? new Date(field.value) ?? null : null}
                                                                    dateFormat='YYYY-MM-dd'
                                                                    inline
                                                                />
                                                                <svg fill="currentColor" className="react-datepicker__triangle__arrow" aria-hidden="true" width="18" height="16" viewBox="0 0 16 16"><path clip-path="url(#«r4»)" fill="none" stroke-width="3" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><path stroke="currentColor" d="M0,0 H16 L8,8 Q8,8 8,8 Z"></path><clipPath id="«r4»"><rect x="-1" y="1" width="18" height="16"></rect></clipPath></svg>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </>
                                        )}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row">
                                <div className="col-5 mt-1 text-end">
                                    <label className="form-label">E-mail</label>
                                </div>
                                <div className="col-7">
                                    <input type="text" {...register("email")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-5 mt-1 text-end">
                                    <label className="form-label">Nadčasy</label>
                                </div>
                                <div className="col-7">
                                    <select {...register("monthOvertimeHours")} className="form-select form-select-sm" >
                                        {
                                            yesNo.map(yn => {
                                                return (
                                                    <option value={yn.id}>{yn.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-5 mt-1 text-end">
                                    <label className="form-label">Alokácie v nepracovné dni</label>
                                </div>
                                <div className="col-7">
                                    <select {...register("nonWorkingDayEntries")} className="form-select form-select-sm" >
                                        {
                                            yesNo.map(yn => {
                                                return (
                                                    <option value={yn.id}>{yn.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-5 mt-1 text-end">
                                    <label className="form-label">Maximum alokovaných hodín na deň</label>
                                </div>
                                <div className="col-7">
                                    <input type="text" {...register("maxDayHours")} className="form-control form-control-sm" />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-5 mt-1 text-end">
                                    <label className="form-label">Štandartne hodín na deň</label>
                                </div>
                                <div className="col-7">
                                    <input type="text" {...register("stdDayHours")} className="form-control form-control-sm" />
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-5 mt-1 text-end">
                                    <label className="form-label">Oprávnenia</label>
                                </div>
                                <div className="col-7">
                                    <select {...register("adminLevel")} className="form-select form-select-sm" >
                                        {
                                            adminLevels.map(yn => {
                                                return (
                                                    <option value={yn.id}>{yn.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className="card mt-5">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-6">
                                    <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "person"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "user-check"]} /></span> Schvalovatelia tejto osoby</div>
                                </div>
                                <div className="col-6 text-end">
                                    {
                                        params.personId === "0" ?
                                            <button className="btn btn-success btn-sm" disabled><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať schvalovateľa</button>
                                            :
                                            <AdminLevel level={9} match="greaterOrEqual">
                                                <button className="btn btn-success btn-sm" onClick={
                                                    () => showModal(
                                                        <AdminAddApproverToUser
                                                            item={null}
                                                            reload={reloadData}
                                                            alreadyAdded={data.approvers}
                                                            addFunction={addApprover}
                                                        />
                                                    )
                                                }><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať schvalovateľa</button>
                                            </AdminLevel>
                                    }

                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            {
                                params.personId !== "0" ?
                                    <table className="table table-bordered table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th>Meno</th>
                                                <th className="text-center" style={{ width: '130px' }}>Akcia</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.approvers.map(approver => {
                                                    return (
                                                        <tr>
                                                            <td>{approver.name} {approver.surname}</td>
                                                            <td className="text-center">
                                                                <AdminLevel level={9} match="greaterOrEqual">
                                                                    <button className="btn btn-danger btn-sm" onClick={
                                                                        () => showModal(
                                                                            <ModalConfirmation
                                                                                confirm={() => removeApprover(approver.personId)}
                                                                                title="Potvrdiť odobratie schvalovateľa"
                                                                            ><div>
                                                                                    <table className="table table-bordered">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td>Schvalovateľ</td>
                                                                                                <td>{approver.name} {approver.surname}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td>Osoba</td>
                                                                                                <td>{getValues().name} {getValues().surname}</td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </ModalConfirmation>
                                                                        )
                                                                    }><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Zmazať</button>
                                                                </AdminLevel>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="text-center">Bude možné pridať po vytvorení osoby</div>
                            }
                        </div>
                    </div>

                    <div className="card mt-5">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-6">
                                    <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "person"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "puzzle-piece"]} /></span> Projekty a ich komponenty na ktoré je osoba priradená</div>
                                </div>
                                <div className="col-6 text-end">
                                    {
                                        params.personId === "0" ?
                                            <button className="btn btn-success btn-sm" disabled><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať komponent</button>
                                            :
                                            <button className="btn btn-success btn-sm" onClick={
                                                () => showModal(
                                                    <AdminAddOrderToUser
                                                        item={null}
                                                        reload={reloadData}
                                                        alreadyAdded={data.orders}
                                                        addFunction={addOrder}
                                                    />
                                                )
                                            }><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať komponent</button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            {
                                params.personId !== "0" ?
                                    <table className="table table-bordered table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th colSpan={2}>Projekt</th>
                                                <th>Komponent</th>
                                                <th className="text-center" style={{ width: '120px' }}>Od</th>
                                                <th style={{ width: '20px' }}></th>
                                                <th className="text-center" style={{ width: '120px' }}>Do</th>
                                                <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.orders.sort((a, b) => Number(b.continuity) - Number(a.continuity)).map(order => {
                                                    const project = lookupFromObjectsArray(data.projects, 'projectId', order.projectId)
                                                    return (
                                                        <tr>
                                                            <td style={{ width: '70px' }}>{project?.nameId}</td>
                                                            <td>{project?.name}</td>
                                                            <td>{order.name}</td>
                                                            <td className="text-center">{order.fromMonth}&nbsp;.&nbsp;{order.fromYear}</td>
                                                            <td className={order.continuity ? 'bg-success-subtle' : 'bg-danger-subtle'}></td>
                                                            <td className="text-center">{
                                                                !order.toMonth || !order.toYear ?
                                                                    'Trvá' : <span>{order.toMonth}&nbsp;.&nbsp;{order.toYear}</span>
                                                            }</td>
                                                            <td className="text-center">

                                                                {
                                                                    currentUser.adminLevel === 9 || currentUser.divisionId === order.divisionId ?
                                                                        <button className="btn btn-danger btn-sm" onClick={
                                                                            () => showModal(
                                                                                <ModalConfirmation
                                                                                    confirm={() => removeOrder(order.orderId)}
                                                                                    title="Potvrdiť odobratie schvalovateľa"
                                                                                ><div>
                                                                                        <table className="table table-bordered">
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    <td>Schvalovateľ</td>
                                                                                                    <td> </td>
                                                                                                </tr>
                                                                                                <tr>
                                                                                                    <td>Osoba</td>
                                                                                                    <td>{getValues().name} {getValues().surname}</td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </ModalConfirmation>
                                                                            )
                                                                        }><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} /> Zmazať</button>
                                                                        : null
                                                                }

                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="text-center">Bude možné pridať po vytvorení osoby</div>
                            }
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">

                            <div className="card mt-5">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "person"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "list-check"]} /></span> Mesačné výkazy vytvorené tejto osobe</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">

                                    <table className="table table-bordered table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '150px' }}>Rok</th>
                                                <th style={{ width: '150px' }}>Mesiac</th>
                                                <th className="text-center">Stav</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.reportings.sort((a, b) => Number(b.year) - Number(a.year) || Number(b.month) - Number(a.month)).map(reporting => {

                                                    return (
                                                        <tr>
                                                            <td>{reporting.year}</td>
                                                            <td>{reporting.month}</td>
                                                            <td className="text-center"><DisplayTimeReportState state={reporting.status} /></td>

                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                        <div className="col-6">

                            <div className="card mt-5">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="mt-1 h7"><span className="text-primary me-2"><FontAwesomeIcon fixedWidth icon={["fas", "person"]} /><FontAwesomeIcon fixedWidth icon={["fas", "arrow-right"]} /><FontAwesomeIcon fixedWidth icon={["fas", "user-check"]} /></span> Schvalovateľ pre tieto osoby</div>
                                        </div>

                                    </div>
                                </div>
                                <div className="card-body">

                                    <table className="table table-bordered table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th>Meno</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.approverFor.map(approver => {
                                                    return (
                                                        <tr>
                                                            <td>{approver.name} {approver.surname}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Person